import axios from "axios"

export default {

    async GetKasaHareketleri(data) {
        const response = await axios.post(`/api/netsisaccountant/get/kasahareketlist`, data)
        return response
    },
    async GetCariList(data) {
        const response = await axios.get(`/api/netsisaccountant/get/cari/list/${data}`)
        return response
    },
    async GetAllCariList() {
        const response = await axios.get(`/api/netsisaccountant/get/all/carihesap`)
        return response
    },
    async GetAllMuhasebeList() {
        const response = await axios.get(`/api/netsisaccountant/get/all/muhasebehesap`)
        return response
    },
    async GetMuPlanList(data) {
        const response = await axios.get(`/api/netsisaccountant/get/muplan/list/${data}`)
        return response
    },
    async GetKDVCodes() {
        const response = await axios.get(`/api/netsisaccountant/get/muplan/list/kdv`)
        return response
    },
    async GetBankList(data) {
        const response = await axios.get(`/api/netsisaccountant/get/banklist/${data}`)
        return response
    },
    async GetNetsisCurrencyData(data) {
        const response = await axios.get(`/api/netsisaccountant/get/kurbilgisi/${data}`)
        return response
    },
    async GetCariKasaHareketToday() {
        const response = await axios.get(`/api/netsisaccountant/get/kasahareket/cari/today`)
        return response
    },
    async GetBankaKasaHareketToday() {
        const response = await axios.get(`/api/netsisaccountant/get/kasahareket/bank/today`)
        return response
    },
    async GetMuhtelifKasaHareketToday() {
        const response = await axios.get(`/api/netsisaccountant/get/kasahareket/muhtelif/today`)
        return response
    },
    async GetTransferKasaHareketToday() {
        const response = await axios.get(`/api/netsisaccountant/get/kasahareket/transfer/today`)
        return response
    },
    async GetFaturaKasaHareketToday() {
        const response = await axios.get(`/api/netsisaccountant/get/kasahareket/fatura/today`)
        return response
    },
    async GetPlasiyerList() {
        const response = await axios.get(`/api/netsisaccountant/get/plasiyerlist`)
        return response
    },
    async GetKasaList() {
        const response = await axios.get(`/api/netsisaccountant/get/kasalist`)
        return response
    },
    async GetBelgeTuruList() {
        const response = await axios.get(`/api/netsisaccountant/get/belgeturulist`)
        return response
    },
    async GetKasaListAll() {
        const response = await axios.get(`/api/netsisaccountant/get/kasalist/all`)
        return response
    },
    async SaveCariKasaHareket(data) {
        const response = await axios.post(`/api/netsisaccountant/create/kasahareket/cari`, data)
        return response
    },
    async SaveBankKasaHareket(data) {
        const response = await axios.post(`/api/netsisaccountant/create/kasahareket/banka`, data)
        return response
    },
    async SaveMuhtelifKasaHareket(data) {
        const response = await axios.post(`/api/netsisaccountant/create/kasahareket/muhtelif`, data)
        return response
    },
    async SaveTransferKasaHareket(data) {
        const response = await axios.post(`/api/netsisaccountant/create/kasahareket/transfer`, data)
        return response
    },
    async TransferKasaToCari(data) {
        const response = await axios.post(`/api/netsisaccountant/create/transferkasatocari`, data)
        return response
    },
    async SaveFaturaKasaHareket(data) {
        const response = await axios.post(`/api/netsisaccountant/create/kasahareket/fatura`, data)
        return response
    },
    async RaporKoduList(){
        const response = await axios.post(`/api/netsisaccountant/get/kasaraporkodulist`)
        return response
    },
    UserOfNetsisKasa:{
        async Table(data){
            const response = await axios.post(`/api/netsisaccountant/userofnetsiskasa/table`,data)
            return response
        },
        async Assign(data){
            const response = await axios.post(`/api/netsisaccountant/userofnetsiskasa/assignusertonetsiskasa`,data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/netsisaccountant/userofnetsiskasa/delete/${id}`)
            return response
        },
        async GetUserOfNetsisKasa(userId){
            const response = await axios.get(`/api/netsisaccountant/userofnetsiskasa/getuserofnetsiskasa/${userId}`)
            return response
        },
        async CollarStatusAuthorize(data){
            const response = await axios.post(`/api/netsisaccountant/userofnetsiskasa/collarstatus/authorize`,data)
            return response
        },
    },
    async TransferWaitingMyApprove(data){
        const response = await axios.post(`/api/netsisaccountant/table/transfer/waitingmyapprove`,data)
        return response
    },
    async TransferApprove(id){
        const response = await axios.post(`/api/netsisaccountant/transfer/approve/${id}`)
        return response
    },
    async BankaFis(fisNo,sira){
        const response = await axios.get(`/api/netsisaccountant/get/banka/fis/${fisNo}/${sira}`)
        return response
    },
    async CariFis(fisNo,sira){
        const response = await axios.get(`/api/netsisaccountant/get/cari/fis/${fisNo}/${sira}`)
        return response
    },
    async FaturaFisTediye(fisNo,sira){
        const response = await axios.get(`/api/netsisaccountant/get/fatura/fis/${fisNo}/${sira}`)
        return response
    },
    async FaturaFis(fisNo,sira){
        const response = await axios.get(`/api/netsisaccountant/get/fatura/fis/${fisNo}/${sira}`)
        return response
    },
    async MuhtelifFis(fisNo,sira){
        const response = await axios.get(`/api/netsisaccountant/get/muhtelif/fis/${fisNo}/${sira}`)
        return response
    },
    async TediyeFis(fisNo,tip,siraNo){
        const response = await axios.get(`/api/netsisaccountant/get/fatura/fis/${fisNo}/${tip}/${siraNo}`)
        return response
    },
    MuhasebePlani:{
        async Table(data){
            const response = await axios.post(`/api/netsisaccountant/table/netsismuhasebehesapplani`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/netsisaccountant/update/netsismuhasebehesapplani` : `/api/netsisaccountant/create/netsismuhasebehesapplani`,data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/netsisaccountant/delete/netsismuhasebehesapplani/${id}`)
            return response
        },
    },
    BankaPlani:{
        async Table(data){
            const response = await axios.post(`/api/netsisaccountant/table/netsisbankahesapplani`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/netsisaccountant/update/netsisbankahesapplani` : `/api/netsisaccountant/create/netsisbankahesapplani`,data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/netsisaccountant/delete/netsisbankahesapplani/${id}`)
            return response
        },
    },
    KasaHesapPlani:{
        async Table(data){
            const response = await axios.post(`/api/netsisaccountant/table/netsiskasahesapplani`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/netsisaccountant/update/netsiskasahesapplani` : `/api/netsisaccountant/create/netsiskasahesapplani`,data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/netsisaccountant/delete/netsiskasahesapplani/${id}`)
            return response
        },
    },
    ReportCode:{
        async Table(data){
            const response = await axios.post(`/api/netsisaccountant/reportcode/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/netsisaccountant/reportcode/update` : `/api/netsisaccountant/reportcode/create`,data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/netsisaccountant/reportcode/delete/${id}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/netsisaccountant/reportcode/list`)
            return response
        },
    },
    async DeleteKasaHareket(sira){
        const response = await axios.post(`/api/netsisaccountant/delete/kasahareket/${sira}`)
        return response
        
    },
    VaultLock:{
        async List(){
            const response = await axios.get(`/api/netsisaccountant/list/vaultlocks`)
            return response
        },
        async ChangeLockStatus(vc){
            const response = await axios.post(`/api/netsisaccountant/change/lockstatus/${vc}`)
            return response
        }
    },
    Komisyon:{
        async DownloadSample(){
            const response = await axios.get(`/api/netsisaccountant/komisyon/downloadsample`,{
                responseType: 'blob',
            })
            return response
        },
        async UploadAndCheck(data){
            const response = await axios.post(`/api/netsisaccountant/komisyon/uploadandcheck`,data,{headers: { "Content-Type": "multipart/form-data" },})
            return response
        },
        async CreateMultiple(data){
            const response = await axios.post(`/api/netsisaccountant/komisyon/createmultiple`,data)
            return response
        },
    },
    VaultLockMonth:{
        async List(){
            const response = await axios.post(`/api/netsisaccountant/list/vaultlockmonth`)
            return response
        },
        async Create(data){
            const response = await axios.post(`/api/netsisaccountant/create/vaultlockmonth`,data)
            return response
        }
    },
    AccountPair:{
        async Table(data){
            const response = await axios.post(`/api/netsisaccountant/account/pair/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/netsisaccountant/account/pair/update/${data.Id}/${data.AccountCode}` : `/api/netsisaccountant/account/pair/create/${data.VaultCode}/${data.AccountCode}`,data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/netsisaccountant/account/pair/delete/${id}`)
            return response
        },
        async List(vaultCode){
            const response = await axios.get(`/api/netsisaccountant/account/pair/list/${vaultCode}`)
            return response
        },
    },
    BelgeTuru:{
        async Table(data){
            const response = await axios.post(`/api/netsisaccountant/belgeturu/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/netsisaccountant/belgeturu/update` : `/api/netsisaccountant/belgeturu/create`,data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/netsisaccountant/belgeturu/delete/${id}`)
            return response
        },
        async List(){
            const response = await axios.get(`/api/netsisaccountant/belgeturu/list`)
            return response
        },
    },
    TrafikCezasıHesapPlanı:{
        async Table(data){
            const response = await axios.post(`/api/netsisaccountant/table/netsiskasatrafikcezasihesapplani`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/netsisaccountant/update/netsiskasatrafikcezasihesapplani` :  `/api/netsisaccountant/create/netsiskasatrafikcezasihesapplani`,data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/netsisaccountant/delete/netsiskasatrafikcezasihesapplani/${id}`)
            return response
        },
    }
}